// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__cSV8S","newExpiryDate":"styles_newExpiryDate__zlOOV","footer":"styles_footer__1nCHk"};